// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dice-roller {
  position: fixed;
  right: 20px;
  width: 60px;
  height: 60px;
  background-color: #df2d11;
  border: none;
  border-radius: 50px;
  cursor: pointer;
  z-index: 1001;  /* Increased from 999 to 1001 to match other UI elements */
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 2px;
  color: white;
  box-shadow: 0px 5px 20px 0px rgba(0, 0, 0, 0.3);
  transition: transform 0.2s ease, width 0.3s ease, height 0.3s ease;
  box-sizing: border-box;
  padding: 0;
}

/* Adjust all positions to accommodate the removed button */
.dice-roller.d4 {
  bottom: 440px; /* Was 510px */
}

.dice-roller.d6 {
  bottom: 370px; /* Was 440px */
}

.dice-roller.d8 {
  bottom: 300px; /* Was 370px */
}

.dice-roller.d10 {
  bottom: 230px; /* Was 300px */
}

.dice-roller.d12 {
  bottom: 160px; /* Was 230px */
}

.dice-roller.d20 {
  bottom: 90px; /* Was 160px */
}

.dice-roller svg {
  width: 24px;
  height: 24px;
  position: relative;
  top: -3px;
  transition: transform 0.3s ease, width 0.3s ease, height 0.3s ease;
}

.dice-roller span {
  font-size: 12px;
  font-family: "Gabarito", serif;
  line-height: 1;
  transition: font-size 0.3s ease;
}

.dice-roller:hover {
  transform: scale(1.05);
}

.dice-roller:disabled {
  cursor: not-allowed;
  opacity: 1;
}

.dice-roller.rolling {
  width: 120px;
  height: 120px;
  transition: width 0.3s ease, height 0.3s ease;
}

.dice-roller.rolling svg {
  width: 48px;
  height: 48px;
  animation: roll 0.5s ease;
  transition: width 0.3s ease, height 0.3s ease;
}

.dice-roller.rolling span {
  font-size: 36px;
  transition: font-size 0.3s ease;
}

.dice-roller:not(.rolling) {
  transition: width 0.3s ease 1s, height 0.3s ease 1s;
}

.dice-roller:not(.rolling) svg {
  transition: width 0.3s ease 1s, height 0.3s ease 1s;
}

.dice-roller:not(.rolling) span {
  transition: font-size 0.3s ease 1s;
}

@keyframes roll {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

@media (max-width: 576px) {
  .dice-roller {
    right: 16px;
  }
  
  .dice-roller.d4 {
    bottom: 360px; /* Was 430px */
    right: 16px;
  }
  
  .dice-roller.d6 {
    bottom: 290px; /* Was 360px */
    right: 16px;
  }
  
  .dice-roller.d8 {
    bottom: 220px; /* Was 290px */
    right: 16px;
  }
  
  .dice-roller.d10 {
    bottom: 150px; /* Was 220px */
    right: 16px;
  }
  
  .dice-roller.d12 {
    bottom: 80px; /* Was 150px */
    right: 16px;
  }
  
  .dice-roller.d20 {
    bottom: 10px; /* Was 80px */
    right: 16px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/DiceRoller.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,WAAW;EACX,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,aAAa,GAAG,0DAA0D;EAC1E,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,+CAA+C;EAC/C,kEAAkE;EAClE,sBAAsB;EACtB,UAAU;AACZ;;AAEA,2DAA2D;AAC3D;EACE,aAAa,EAAE,cAAc;AAC/B;;AAEA;EACE,aAAa,EAAE,cAAc;AAC/B;;AAEA;EACE,aAAa,EAAE,cAAc;AAC/B;;AAEA;EACE,aAAa,EAAE,cAAc;AAC/B;;AAEA;EACE,aAAa,EAAE,cAAc;AAC/B;;AAEA;EACE,YAAY,EAAE,cAAc;AAC9B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,SAAS;EACT,kEAAkE;AACpE;;AAEA;EACE,eAAe;EACf,8BAA8B;EAC9B,cAAc;EACd,+BAA+B;AACjC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,6CAA6C;AAC/C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,6CAA6C;AAC/C;;AAEA;EACE,eAAe;EACf,+BAA+B;AACjC;;AAEA;EACE,mDAAmD;AACrD;;AAEA;EACE,mDAAmD;AACrD;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,KAAK,uBAAuB,EAAE;EAC9B,OAAO,yBAAyB,EAAE;AACpC;;AAEA;EACE;IACE,WAAW;EACb;;EAEA;IACE,aAAa,EAAE,cAAc;IAC7B,WAAW;EACb;;EAEA;IACE,aAAa,EAAE,cAAc;IAC7B,WAAW;EACb;;EAEA;IACE,aAAa,EAAE,cAAc;IAC7B,WAAW;EACb;;EAEA;IACE,aAAa,EAAE,cAAc;IAC7B,WAAW;EACb;;EAEA;IACE,YAAY,EAAE,cAAc;IAC5B,WAAW;EACb;;EAEA;IACE,YAAY,EAAE,aAAa;IAC3B,WAAW;EACb;AACF","sourcesContent":[".dice-roller {\n  position: fixed;\n  right: 20px;\n  width: 60px;\n  height: 60px;\n  background-color: #df2d11;\n  border: none;\n  border-radius: 50px;\n  cursor: pointer;\n  z-index: 1001;  /* Increased from 999 to 1001 to match other UI elements */\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  gap: 2px;\n  color: white;\n  box-shadow: 0px 5px 20px 0px rgba(0, 0, 0, 0.3);\n  transition: transform 0.2s ease, width 0.3s ease, height 0.3s ease;\n  box-sizing: border-box;\n  padding: 0;\n}\n\n/* Adjust all positions to accommodate the removed button */\n.dice-roller.d4 {\n  bottom: 440px; /* Was 510px */\n}\n\n.dice-roller.d6 {\n  bottom: 370px; /* Was 440px */\n}\n\n.dice-roller.d8 {\n  bottom: 300px; /* Was 370px */\n}\n\n.dice-roller.d10 {\n  bottom: 230px; /* Was 300px */\n}\n\n.dice-roller.d12 {\n  bottom: 160px; /* Was 230px */\n}\n\n.dice-roller.d20 {\n  bottom: 90px; /* Was 160px */\n}\n\n.dice-roller svg {\n  width: 24px;\n  height: 24px;\n  position: relative;\n  top: -3px;\n  transition: transform 0.3s ease, width 0.3s ease, height 0.3s ease;\n}\n\n.dice-roller span {\n  font-size: 12px;\n  font-family: \"Gabarito\", serif;\n  line-height: 1;\n  transition: font-size 0.3s ease;\n}\n\n.dice-roller:hover {\n  transform: scale(1.05);\n}\n\n.dice-roller:disabled {\n  cursor: not-allowed;\n  opacity: 1;\n}\n\n.dice-roller.rolling {\n  width: 120px;\n  height: 120px;\n  transition: width 0.3s ease, height 0.3s ease;\n}\n\n.dice-roller.rolling svg {\n  width: 48px;\n  height: 48px;\n  animation: roll 0.5s ease;\n  transition: width 0.3s ease, height 0.3s ease;\n}\n\n.dice-roller.rolling span {\n  font-size: 36px;\n  transition: font-size 0.3s ease;\n}\n\n.dice-roller:not(.rolling) {\n  transition: width 0.3s ease 1s, height 0.3s ease 1s;\n}\n\n.dice-roller:not(.rolling) svg {\n  transition: width 0.3s ease 1s, height 0.3s ease 1s;\n}\n\n.dice-roller:not(.rolling) span {\n  transition: font-size 0.3s ease 1s;\n}\n\n@keyframes roll {\n  0% { transform: rotate(0deg); }\n  100% { transform: rotate(360deg); }\n}\n\n@media (max-width: 576px) {\n  .dice-roller {\n    right: 16px;\n  }\n  \n  .dice-roller.d4 {\n    bottom: 360px; /* Was 430px */\n    right: 16px;\n  }\n  \n  .dice-roller.d6 {\n    bottom: 290px; /* Was 360px */\n    right: 16px;\n  }\n  \n  .dice-roller.d8 {\n    bottom: 220px; /* Was 290px */\n    right: 16px;\n  }\n  \n  .dice-roller.d10 {\n    bottom: 150px; /* Was 220px */\n    right: 16px;\n  }\n  \n  .dice-roller.d12 {\n    bottom: 80px; /* Was 150px */\n    right: 16px;\n  }\n  \n  .dice-roller.d20 {\n    bottom: 10px; /* Was 80px */\n    right: 16px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
